export enum REMOTE_FILTERS {
  ALL = 'all',
  REMOTE = 'remote',
  OFFICE = 'office',
}

export enum GUEST_FILTER {
  NOT_ALONE = 'notAlone',
  WITHOUT_CHILDREN = 'withoutChildren',
  WITH_CHILDREN = 'withChildren',
}
